import React, { forwardRef } from 'react';
import { Table as AntTable } from 'antd';
import { useLayoutSizing } from './LayoutSizingScope';
import { useTableViewport } from './useTableViewport';
import './viewport-table.css';

export const Table = forwardRef(function ViewportTable(props, ref) {
  const { tables } = useLayoutSizing();
  const { tableRef, height } = useTableViewport(tables);
  if (!tables) return <AntTable {...props} ref={ref} />;
  return <div ref={tableRef} className="srm-viewport-table" style={{ '--srm-table-body-height': `${height}px` }}>
    <AntTable {...props} ref={ref} sticky={props.sticky ?? true} scroll={{ ...props.scroll, y: height }} />
  </div>;
});
Object.keys(AntTable).filter(key => !['render', '$$typeof', 'displayName'].includes(key)).forEach(key => { Table[key] = AntTable[key]; });
